var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pt-4 px-8 md:ml-12"},[(_vm.isLoading)?_c('div',[_c('div',{staticClass:"flex items-center justify-center w-full h-screen -mt-32"},[_c('spinner',{attrs:{"size":"medium","spacing":40,"line-fg-color":_vm.$primaryColor}})],1)]):_c('div',[_c('div',[(_vm.isCustomersPage)?_c('customers-page'):_vm._e()],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }